module.exports = __webpack_public_path__ + "static/media/white-bricks.d2c3f607.png";